import { useState } from 'react';
import { GlobalProvider } from './context/GlobalProvider';

import Pages from './Pages/Pages';
import { BMToken } from './hook/Token';
import ResourceEnvironment from './hook/ResourceEnvironment';

import './App.scss';

function App() {
    const [env, setEnv] = useState(false);
    const [bmToken, setBMToken] = useState(false);

    return (
        <GlobalProvider>
            <ResourceEnvironment setEnv={setEnv} />
            <BMToken setBMToken={setBMToken} />
            {env && bmToken && <Pages />}
        </GlobalProvider>
    )
}

export default App;